import { APIClient } from '@autopylot-internal/autopylot-api-client';
import { Directory, Encoding, Filesystem } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { Device } from '../../support/Device.ts';
import { TrackingService } from '../../support/tracking/TrackingService.ts';

export class BulkMissionExport {
    static inject = () => [APIClient, Device, TrackingService];
    constructor(private apiClient: APIClient, private device: Device, private tracking: TrackingService){
        this.isNative = (['ios', 'android'].includes(this.device.platform));
    }

    private isNative: boolean;

    exportToCSV = async () => {
        const entry = await this.apiClient.entry();
        const csv = await this.apiClient.get(entry.links.missions, 'text/csv');
        if (this.isNative){
            await this.shareCSV(csv.toString());
        }
        else {
            this.tracking.trackWithDebounce('Missions (csv) Shared', () => ({ activityType: 'web' }));
            await this.webDownloadCSV(csv.toString());
        }
    };

    private webDownloadCSV = async (csv: string) => {
        const blob = new Blob([csv], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', 'autopylot_missions_export.csv');
        link.style.display = 'none';
        document.body.appendChild(link); // Required for FF

        link.click();

        document.body.removeChild(link);
    };

    private shareCSV = async (csv: string) => {
        const directory = Directory.Data;
        const path = 'export';

        try {
            await Filesystem.mkdir({ directory, path });
        } catch (e) {
            // ignore if directory already exists
        }
        const fileName = `autopylot_missions_export.csv`;
        const { uri } = await Filesystem.writeFile({
            data: csv,
            encoding: Encoding.UTF8,
            path: `${path}/${fileName}`,
            directory
        });
        try {
            const { activityType } = await Share.share({
                url: uri
            });
            this.tracking.trackWithDebounce('Missions (csv) Shared', () => ({
                activityType
            }));
        }
        catch(shareError: any){
            // If the user cancelled sharing, don't throw
            if (shareError.toString().toLowerCase().includes('share canceled')) {
                this.tracking.trackWithDebounce('Missions (csv) Shared', () => ({
                    cancelled: true
                }));
                return;
            }
            throw shareError;
        }
    };
}
